<template>
  <div class="equipment-list-container">
    <div class="jc-page-top">
      <div class="equipment-list">
        <div class="jc-page-header">
          <h1>
            <i class="jc-icon-my-circle-bold"></i>{{$t('text.equipment')}}
          </h1>
          <div class="jc-box-action">
            <a v-bind:href="Config.EUQIPMENT_SERVER_URL" target="_blank">{{$t('equipment.helpDoc',[$t('text.equipment')])}}</a>
          </div>
        </div>

        <div class="jc-page-content">
          <div class="el-container-table">
            <!-- 表头操作 -->
            <div class="el-container-table-actionBar">
              <el-form class="el-box-table-search" :inline="true" @submit.native.prevent>
                <el-form-item>
                  <el-select id="my-select" v-model="currentSearch" @change="changeSearch" class="search-select-width">
                    <el-option class="my-select-input" v-for="item in searchSelect" :key="item.searchValue" :label="item.searchLabel" :value="item.searchValue"></el-option>
                  </el-select>
                  <el-input class="my-input" v-on:input="delAllSearchVal" clearable @clear="updateList('refresh')" @keyup.enter.native="filterBySearchValue" :placeholder="searchPlaceholder[currentSearch]" v-model="currentSearchValue">
                    <el-button slot="append" icon="el-icon-search" @click="filterBySearchValue" class="search-icon"></el-button>
                  </el-input>
                </el-form-item>
                <!-- tag -->
                <el-form-item>
                  <jcb-tag-filter :service-code="ServiceCodeConstant.CCS"
                                  :visible.sync="batchEditTagDialogVisible"
                                  :region-id="TagRegionID"
                                  @checkedTags="filterWithCheckedTags">
                  </jcb-tag-filter>
                </el-form-item>
                <el-form-item class="set-icon">
                  <el-button icon="el-icon-setting" class="el-button-icon" @click="customVisible = true" :title="$t('merge.customList')"></el-button>
                </el-form-item>
                <el-form-item>
                  <el-button class="el-button-icon" icon="jc-icon-download" @click="exportList" :title="$t('speechcraft.exportResourceList')"></el-button>
                </el-form-item>
              </el-form>
              <el-form class="el-table-actionBar-item" :inline="true">
                <el-form-item>
                  <el-button icon="jc-icon-refresh-line" class="el-button-icon" @click="updateList('refresh')" v-if="idc_map.length"></el-button>
                </el-form-item>
                <el-form-item>
                  <!-- <el-radio-group v-model="idcId" @click="selectRegion">
                    <el-radio-group-advance :max-shown-count="5" more-trigger="click" :more-label="$t('text.moreNode')">
                      <el-radio-button v-for="room in idc_map"
                                    :key="room.idc"
                                    :label="room.idc"
                        >{{ room.idcName }}</el-radio-button
                      >
                    </el-radio-group-advance>
                  </el-radio-group> -->
                  <el-select v-model="idcId" @click="selectRegion" :placeholder="$t('placeholder.choose')">
                    <el-option
                      v-for="room in idc_map"
                      :key="room.idc"
                      :value="room.idc"
                      :label="room.idcName">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div class="el-container-table">
              <el-table  @sort-change="handleSortChange"  @selection-change="handleSelectionChange" :data="equipmentTable" v-loading="refreshLoading" ref="equipmentDataTable" @filter-change="filterChange" :empty-text="tableEmptyTip">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <!-- 设备编码 -->
                <el-table-column sortable :label="$t('equipment.equipmentNumber')+ '(ID)'"
                                 v-if="customInfo !== null && customInfo['deviceNo'].selected"
                                 prop="deviceNo" min-width="190">
                  <template slot-scope="scope">
                    <a v-if="scope.row.deviceNo != ''" href="javascript:void(0)" @click="jump_to_detail(idcId,scope.row.deviceId)">{{scope.row.deviceNo}}</a>
                    <a v-else href="javascript:void(0)" @click="jump_to_detail(idcId,scope.row.deviceId)">--</a>
                  </template>
                </el-table-column>
                <!-- SN号 -->
                <el-table-column :label="$t('equipment.snNumber')" v-if="customInfo !== null &&
                customInfo['snNo'].selected" min-width="150">
                  <template slot-scope="scope">
                    <span v-if="scope.row.snNo != ''">{{scope.row.snNo}}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <!-- 机柜编码 -->
                <el-table-column sortable :label="$t('cabinet.cabinetNumCode')" v-if="customInfo !== null && customInfo['cabinetNo'].selected" prop="cabinetNo">
                  <template slot-scope="scope">
                    <span v-if="scope.row.cabinetNo != ''">{{scope.row.cabinetNo}}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <!-- 所在U位 -->
                <el-table-column :label="$t('text.belongUbit')" v-if="customInfo !== null && customInfo['rackUIndex'].selected">
                  <template slot-scope="scope">
                    <span v-if="scope.row.rackUIndex != ''">{{scope.row.rackUIndex}}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <!-- U数(U) -->
                <el-table-column :label="$t('equipment.uNo')" v-if="customInfo !== null && customInfo['uNum'].selected">
                  <template slot-scope="scope">
                    <span v-if="scope.row.uNum != ''">{{scope.row.uNum}}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <!-- 品牌 -->
                <el-table-column :label="$t('text.brand')" v-if="customInfo !== null && customInfo['brand'].selected">
                  <template slot-scope="scope">
                    <span v-if="scope.row.brand != ''">{{scope.row.brand}}</span>
                    <span v-else></span>
                  </template>
                </el-table-column>
                <!-- 型号 -->
                <el-table-column :label="$t('text.model')" v-if="customInfo !== null && customInfo['model'].selected">
                  <template slot-scope="scope">
                    <span v-if="scope.row.model != ''">{{scope.row.model}}</span>
                    <span v-else></span>
                  </template>
                </el-table-column>
                <!-- 设备类型 -->
                <el-table-column prop="equipmentType" :label="$t('equipment.equipmentType')" :filter-multiple="false" :filter-method="filterEquipmentType" :filtered-value="filterEquipment" :filters="deviceTypes" v-if="customInfo !== null && customInfo['deviceType'].selected" column-key="filterType">
                  <template slot-scope="scope">
                    <span v-if="scope.row.deviceTypeName != ''">{{scope.row.deviceTypeName}}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <!-- 设备状态 -->
                <el-table-column prop="equipmentStatus" :label="$t('equipment.equipmentStatus')" :filter-multiple="false" :filter-method="filterEquipmentStatus" :filtered-value="filterEquipments" :filters="deviceStatus" v-if="customInfo !== null && customInfo['assetStatus'].selected" column-key="filterStatus">
                  <template slot-scope="scope">
                    <span v-if="scope.row.assetStatusName != ''">{{scope.row.assetStatusName}}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <!--<el-table-column :label="$t('text.note')" v-if="header_if_table['note']">-->
                <!--<template slot-scope="scope">-->
                <!--<span>{{scope.row.note}}</span>-->
                <!--</template>-->
                <!--</el-table-column>-->
                <el-table-column :label="$t('equipment.assetBelonging')"
                                 prop="assetBelong"
                                 :filter-multiple="false"
                                 :filter-method="filterEquipmentBelongs"
                                 :filters="deviceBelongs"
                                 v-if="customInfo !== null && customInfo['assetBelong'].selected"
                                 column-key="filterBelongs"
                                 min-width="90">
                  <template slot-scope="scope">
                    <span>{{ scope.row.assetBelongName | maybeEmpty }}</span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('cabinet.EnablingTime')"
                                 prop="deviceOpenTime"
                                 v-if="customInfo !== null && customInfo['deviceOpenTime'].selected">
                  <template slot-scope="scope">
                    <span>{{ scope.row.deviceOpenTime | maybeEmpty }}</span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('text.tags')"
                              key="tags"
                              v-if="customInfo !== null && customInfo['tags'].selected"
                               min-width="150"
                              class-name="p-line-break">
                <template slot-scope="scope">
                  <p>{{scope.row.tagPairs | maybeEmpty}}</p>
                </template>
              </el-table-column>
              </el-table-column>
                <!--操作-->
                <!-- <el-table-column key="operate"
                                    min-width="100"
                                 :label="$t('text.operate')">
                  <template slot-scope="scope">
                    <div style="display:flex">
                      <el-button type="text"
                                @click="clickOperateTag(scope.row)">
                        {{ $t('text.editTag') }}
                      </el-button>

                    </div>
                  </template>
                </el-table-column> -->
              </el-table>
                <!--<el-table-column :label="$t('cabinet.rentingTime')"-->
                                 <!--prop="startTime"-->
                                 <!--v-if="customInfo !== null && customInfo['startTime'].selected">-->
                  <!--<template slot-scope="scope">-->
                    <!--<span>{{ scope.row.startTime | maybeEmpty }}</span>-->
                  <!--</template>-->
                <!--</el-table-column>-->
                <!--<el-table-column :label="$t('cabinet.expireTime')"-->
                                 <!--prop="endTime"-->
                                 <!--v-if="customInfo !== null && customInfo['endTime'].selected">-->
                  <!--<template slot-scope="scope">-->
                    <!--<span>{{ scope.row.endTime | maybeEmpty }}</span>-->
                  <!--</template>-->
                <!--</el-table-column>-->
              </el-table>
            </div>
            <custom :visible.sync="customVisible" v-if="customVisible" :optionArr="optionArr" :type="type"></custom>
          </div>
        </div>
      </div>
    </div>
    <div class="el-page-footer block el-container-table-actionBar" v-if="equipmentTable.length">
      <el-tooltip class="item" effect="dark" :content="$t('text.pleaseSelectResource')" :disabled="!!multipleSelection.length" :visible-arrow="false" placement="top">
        <el-button type="primary" class="margin-top-ten"  :disabled="!multipleSelection.length" @click="batchEditTag">{{$t('text.editTag')}}</el-button>
      </el-tooltip>
      <el-pagination  @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <!--编辑标签-->
    <jcb-tag-edit :visible.sync="editTagDialogVisible"
                  :service-code="ServiceCodeConstant.CCS"
                  :region-id="TagRegionID"
                  :resource-ids="resourceId"
                  @complete="updateList('refresh')">
    </jcb-tag-edit>
  </div>
</template>


<script>
import { cloneDeep } from 'lodash';
import limit from '../common/limit/Limit.vue';
import custom from '../common/custom/Custom.vue';
import { ServiceCodeConstant } from '@/common/Constants';

const initPage = 1;
export default {
  components: {
    limit,
    custom
  },
  data() {
    return {

      equipmentTable: [],
      idc_map: [],
      idcId: '',
      regionMap: {},
      equipmentTypeMap: {
        server: this.$t('devicetypes.type1'),
        net: this.$t('devicetypes.type2'),
        storage: this.$t('devicetypes.type3'),
        other: this.$t('devicetypes.type4'),
      },
      filterEquipment: [],
      filterEquipments: [],
      currentPage: initPage,
      gotoPage: 20,
      pageSize: 20, // 默认每页20条
      pageSizes: [20, 50, 100], // 可选每页展示多少条
      total: 0,
      refreshLoading: false,
      snSearch: '',
      custom_table_column_visible: false,
      table_header_label: {
        'snNumber': true,
        'cabinetNumbered': true,
        'brand': false,
        'model': false,
        'equipmentStatus': true,
        'equipmentType': true,
        'ubit': true,
        // "note": true,
      },
      header_if_table: {
        'snNumber': true,
        'cabinetNumbered': true,
        'brand': false,
        'model': false,
        'equipmentType': true,
        'equipmentStatus': true,
        'ubit': true,
        // "note": true,
      },
      filteredValue: {
        equipmentFilteredStatus: [],
        equipmentFilteredTypes: []
      },
      currentStatus: '',
      currentType: '',
      currentBelong: '', // 资产所属当前值
      notFirst: false,
      firstTime: true,
      // table筛选无结果提示
      tableEmptyTip: this.$t('text.noSearch'),
      // 自定义列表是否显示
      customVisible: false,
      // 自定义列表表头
      optionArr: [
        {
          // 设备编码
          label: `${this.$t('equipment.equipmentNumber')}(ID)`,
          value: 'deviceNo'
        }, {
          // SN号
          label: this.$t('equipment.snNumber'),
          value: 'snNo'
        },
        {
          // 机柜编号
          label: this.$t('cabinet.cabinetNumCode'),
          value: 'cabinetNo'
        },
        {
          // 所在U位
          label: this.$t('text.belongUbit'),
          value: 'rackUIndex'
        },
        {
          // U数(U)
          label: this.$t('equipment.uNo'),
          value: 'uNum'
        },
        {
          // 品牌
          label: this.$t('text.brand'),
          value: 'brand'
        },
        {
          // 型号
          label: this.$t('text.model'),
          value: 'model'
        },
        {
          // 设备类型
          label: this.$t('equipment.equipmentType'),
          value: 'deviceType'
        },
        {
          // 设备状态
          label: this.$t('equipment.equipmentStatus'),
          value: 'assetStatus'
        },
        // 资产所属
        {
          label: this.$t('equipment.assetBelonging'),
          value: 'assetBelong'
        },
        // 开通时间
        {
          label: this.$t('cabinet.EnablingTime'),
          value: 'deviceOpenTime'
        },
        {
          // 标签
          label: this.$t('text.tags'),
          value: 'tags'
        }
        // {
        //   // 操作
        //   label: this.$t('text.operate'),
        //   value: 'operation'
        // }
        // 起租时间
        // {
        //   label: this.$t('cabinet.rentingTime'),
        //   value: 'startTime'
        // },
        // 退租时间
        // {
        //   label: this.$t('cabinet.expireTime'),
        //   value: 'endTime'
        // }
      ],
      // 自定义列表类型
      type: 'device',
      // 当前排序列
      curProp: '',
      // 当前排序是增序还是降序
      curOrder: '',
      // 模糊搜索下拉框
      searchSelect: [
        // 设备编码
        {
          searchValue: 'deviceNo',
          searchLabel: `${this.$t('equipment.equipmentNumber')}(ID)`
        },
        // SN号
        {
          searchValue: 'snNo',
          searchLabel: this.$t('equipment.snNumber'),
        }
      ],
      currentSearch: 'deviceNo',
      searchPlaceholder: {
        deviceNo: this.$t('placeholder.searchMoreDeviceNo'),
        snNo: this.$t('placeholder.searchMoreSN'),
      },
      currentSearchValue: '',
      // 编辑标签组件是否显示
      editTagDialogVisible: false,
      // 批量编辑标签组件是否显示
      batchEditTagDialogVisible: true,
      resourceId: [],
      // 标签过滤后的资源ID
      filteredResourceIds: [],
      multipleSelection: [],
    };
  },
  methods: {
    batchEditTag() {
      this.resourceId = [];
      this.multipleSelection.forEach((item) => {
        this.resourceId.push(item.deviceId);
      });
      this.editTagDialogVisible = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    clickOperateTag (data) {
      this.resourceId = [].concat([data.deviceId]);
      this.editTagDialogVisible = true;
    },
    /**
     **@disc: 根据标签对实例进行过滤
     */
    filterWithCheckedTags(filterTags, tagKeys, resourceIds) {
      console.log(filterTags, tagKeys, resourceIds);
      if (tagKeys.length !== 0) {
        this.filteredResourceIds = resourceIds;
      } else {
        this.filteredResourceIds = [];
      }
      this.updateList();
    },
    updateList(type, change) {
      this.tableEmptyTip = this.$t('text.noSearch');
      const target = this;

      if (type === 'refresh') {
        this.refreshLoading = true;
      }
      target.getEquipmentsList(type, change);
    },
    filterBySn() {
      if (!this.needRequireResource) {
        return;
      }
      this.refreshLoading = true;
      this.tableEmptyTip = this.$t('text.noSearch');
      this.getEquipmentsList();
    },
    getRegion() {
      const target = this;
      target.$api.getRegions({ all: 1, idcLine: this.GLOBAL.IDCLINE }).then((response) => {
        const temp = response;
        if (temp.errno === 10000 && temp.errmsg === 'OK') {
          if (temp.data && temp.data.idcs.length > 0 && temp.data.idcs[0] != null) {
            target.idc_map = temp.data.idcs;
            if (this.$route.query.selectRoom !== undefined) {
              this.$nextTick(() => {
                this.idcId = this.$route.query.selectRoom;
              })
            } else if (temp.data.idcs) {
              this.$nextTick(() => {
                this.idcId = temp.data.idcs[0].idc;
              })
            }
            this.$nextTick(() => {
              this.idcId.length && target.selectRegion('refresh');
            })
          } else {
            target.fliter_region = [];
          }
        } else {
          this.$message.error(temp.errmsg);
        }
      });
    },
    selectRegion (type = 'change') {
      if (this.idc_map.length > 0) {
        this.$refs.equipmentDataTable.clearFilter();
        this.updateList('refresh', type);
        this.notFirst = true;
        this.snSearch = '';
      }
    },
    getEquipmentsList(type = null, change) {
      if (!this.needRequireResource) {
        return;
      }
      const target = this;
      if (change == 'change') {
        target.currentPage = 1;
        target.tableEmptyTip = this.$t('text.noSearch');
      }
      const params = {
        idc: target.idcId,
        pageNumber: target.currentPage,
        pageSize: target.pageSize
      };
      // debugger;
      // if (type != 'refresh') {
      if (this.currentType != '') {
        target.tableEmptyTip = this.$t('text.hasSearch');
        params.deviceType = this.currentType;
      }
      if (this.currentStatus != '') {
        target.tableEmptyTip = this.$t('text.hasSearch');
        params.assetStatus = this.currentStatus;
      }
      if (this.currentBelong !== '') {
        target.tableEmptyTip = this.$t('text.hasSearch');
        params.assetBelong = this.currentBelong;
      }
      // }
      //
      // if (this.snSearch != '' && type != 'refresh') {
      //   target.tableEmptyTip = this.$t('text.hasSearch');
      //   params.snNo = this.snSearch;
      // }

      const searchValue = target.currentSearchValue;
      const search = target.currentSearch;
      // 判断当前搜索条件，根据不同搜索条件设置不同的请求参数
      if (searchValue != '') {
        switch (search) {
          // SN号
          case 'deviceNo': {
            params.deviceNo = this.$Pop.searchRegularConversion(searchValue);
            break;
          }
          // 客户名称
          case 'snNo': {
            params.snNo = this.$Pop.searchRegularConversion(searchValue);
            break;
          }
        }
      }
      // 是否通过标签进行筛选
      if (this.filteredResourceIds.length) {
        params.deviceId = this.filteredResourceIds.join(',');
      }
      // 判断当前排序条件
      // 是否排序
      console.log(this.curProp);
      if (this.curProp && this.curOrder) {
        params.sortName = this.curProp;
        params.sortDirection = this.curOrder;
      }

      this.$api.getEquipmentList(params).then((response) => {
        if (type === 'refresh') {
          this.refreshLoading = false;
        }
        if (response.errno === 10000 && response.data) {
          const equipmentList = response.data.devices;
          target.total = response.data.totalCount;
          target.equipmentTable = cloneDeep(equipmentList);
          target.equipmentTable.forEach((item) => {
            item.tagPairs = '';
            if (item.tags !== undefined && item.tags.length > 0) {
              item.tags.forEach((tag) => {
                item.tagPairs += `${tag.key}:${tag.value},`;
              });
              item.tagPairs = item.tagPairs.substring(0, item.tagPairs.length - 1);
            }
          });
          this.refreshLoading = false;
        }
      }).finally(() => {
        this.refreshloading = false;
        this.filteredResourceIds = [];
      });
    },
    filterEquipmentType(value, row) {
      // if (row.deviceTypeName === value) {
      //   this.deviceTypeName = row.deviceTypeName;
      //   return true;
      // }
      return true;
    },
    filterEquipmentStatus(value, row) {
      // if (row.assetStatusName === value) {
      //   this.assetStatusName = row.assetStatusName;
      //   return true;
      // }
      return true;
    },
    /**
     * 设备所属filter-methods
     * @param value
     * @param row
     * @return {Boolean}
     */
    filterEquipmentBelongs() {
      return true;
    },
    jump_to_detail(idcId, deviceId) {
      const routeData = this.$router.resolve({
        path: '/equipment/detail',
        query: {
          idcId,
          deviceId
        }
      });
      window.open(routeData.href, '_blank');
    },
    checkPage() {
      const minPage = 1;
      let maxPage = Math.ceil(this.total / this.pageSize);
      if (maxPage < minPage) {
        maxPage = minPage;
      }
      if (this.gotoPage <= minPage) {
        this.gotoPage = 1;
        $('#firstPage').addClass('no').siblings().removeClass('no');
      }
      if (this.gotoPage >= maxPage) {
        this.gotoPage = maxPage;
        $('#lastPage').addClass('no').siblings().removeClass('no');
      }
      if (minPage == maxPage) {
        $('#firstPage').addClass('no').siblings().removeClass('no');
        $('#lastPage').addClass('no');
      }
    },
    exportList() {
      if (!this.needRequireResource) {
        return;
      }
      let url = `/ccs-api/api/resource/exportDevices?idc=${this.idcId}&pageNumber=${this.currentPage}&pageSize=${this.pageSize}&all=1`;
      if (this.currentType != '' && this.currentType !== undefined) {
        url = `${url}&deviceType=${this.currentType}`;
      }
      if (this.currentStatus != '' && this.currentStatus !== undefined) {
        url = `${url}&assetStatus=${this.currentStatus}`;
      }
      if (this.currentBelong !== '' && this.currentBelong !== undefined) {
        url = `${url}&assetBelong=${this.currentBelong}`;
      }
      if (this.curProp && this.curOrder) {
        url = `${url}&sortName=${this.curProp}&sortDirection=${this.curOrder}`;
      }
      const searchValue = this.currentSearchValue;
      const search = this.currentSearch;
      // 判断当前搜索条件，根据不同搜索条件设置不同的请求参数
      if (searchValue != '') {
        switch (search) {
          // SN号
          case 'deviceNo': {
            url = `${url}&deviceNo=${this.$Pop.searchRegularConversion(searchValue)}`;
            break;
          }
          // 客户名称
          case 'snNo': {
            url = `${url}&snNo=${this.$Pop.searchRegularConversion(searchValue)}`;
            break;
          }
        }
      }
      console.log(url);
      window.open(url, '_self');
    },
    handleSizeChange(val) {
      this.pageSize = val;
      // console.log(this.pageSize)
      this.updateList('refresh');
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      // console.log(this.currentPage)
      this.updateList('refresh');
    },
    filterChange(filter) {
      console.log(filter, 'see-filter');
      if (this.notFirst && !this.firstTime) {
        this.currentType = '';
        this.currentStatus = '';
        this.currentBelong = '';
      } else {
        for (const key in filter) {
          if (key == 'filterType') {
            this.currentType = filter.filterType[0];
          }
          if (key == 'filterStatus') {
            this.currentStatus = filter.filterStatus[0];
          }
          if (key === 'filterBelongs') {
            this.currentBelong = filter.filterBelongs[0];
          }
        }
      }
      this.updateList();
    },
    getCustomInfo() {
      const param = {
        pageKey: this.type
      };
      this.$api.getCustomInfo(param).then((response) => {
        // var response = JSON.parse(res)
        if (response.errno === 10000 && response.data.customInfo) {
          this.$store.commit('GET_CUSTOMINFO', { value: response.data.customInfo, type: this.type });
        }
      });
    },
    // 转化概览页所传参数
    transformParams() {
      const param = this.$route.query.currentParam;
      const typeArray = ['server', 'network', 'memory', 'other'];
      const statusArray = ['opened', 'launched', 'operating', 'modifying', 'canceling'];
      if (typeArray.indexOf(param) !== -1) {
        this.currentType = param;
        this.filterEquipment.push(param);
      } else if (statusArray.includes(param)) {
        this.currentStatus = param;
        this.filterEquipments.push(param);
      }
    },
    // 设备编码排序
    handleSortChange({ column, prop, order }) {
      console.log(column, prop, order);
      if (prop && order) {
        this.curProp = prop;
        if (order.indexOf('desc') !== -1) {
          this.curOrder = 'desc';
        }
        if (order.indexOf('asc') !== -1) {
          this.curOrder = 'asc';
        }
      } else {
        this.curProp = null;
        this.curOrder = null;
      }
      this.getEquipmentsList();
    },
    // 修改搜索条件
    changeSearch() {
      // 清空当前搜索条件
      this.currentSearchValue = '';
    },
    // 逐个清除搜索条件
    delAllSearchVal() {
      if (this.currentSearchValue == '') {
        this.updateList('refresh');
      }
    },
    // 按照指定搜索条件进行搜索
    filterBySearchValue() {
      if (!this.needRequireResource) {
        return;
      }
      this.refreshLoading = true;
      this.tableEmptyTip = this.$t('text.noSearch');
      this.getEquipmentsList(null, 'change');
    },
  },
  created() {
    if (JSON.stringify(this.$route.query) !== '{}') {
      this.transformParams();
    }
    if (this.$store.state.customInfo[this.type] === null) {
      this.getCustomInfo();
    }
  },
  computed: {
    ServiceCodeConstant: () => ServiceCodeConstant,
    needRequireResource () {
      // return !!this.idcId
      return true;
    },

    deviceStatus() {
      const equipmentStatus = [];

      if (this.$store.state.filter.filterList && this.$store.state.filter.filterList.assetStatus !== undefined) {
        this.$store.state.filter.filterList.assetStatus.forEach((item) => {
          equipmentStatus.push({ 'text': item.text, 'value': item.value });
        });
      }
      return equipmentStatus;
    },
    deviceTypes() {
      const equipmentTypes = [];
      if (this.$store.state.filter.filterList && this.$store.state.filter.filterList.deviceType !== undefined) {
        this.$store.state.filter.filterList.deviceType.forEach((item) => {
          equipmentTypes.push({ 'text': item.text, 'value': item.value });
        });
      }
      return equipmentTypes;
    },
    /**
     * 返回资产所属过滤字段
     * @return {Array}
     */
    deviceBelongs() {
      const belongs = [];
      if (this.$store.state.filter.filterList
        && typeof this.$store.state.filter.filterList.assetBelong !== 'undefined') {
        this.$store.state.filter.filterList.assetBelong.forEach((item) => {
          belongs.push({
            text: item.text,
            value: item.value
          });
        });
      }
      return belongs;
    },
    customInfo () {
      return this.$store.state.customInfo[this.type];
    }
  },
  mounted() {
    this.getRegion();
    this.checkPage();
  },
  watch: {
    filteredValue: {
      handler(val, oldVal) {
        this.updateList('refresh');
      },
      deep: true
    },
    idcId (newVal, oldVal) {
      console.log(newVal, oldVal);
      // 切换机房
      this.updateList('refresh');
    }
  },
};
</script>
<style lang="scss">
.equipment-list-container {
  /* // 设置footer分页(勿动) */
  background-color: #ebf1f6;
  height: 100% ;
  overflow: auto;

  //消除table滚动
  .el-table__body-wrapper {
    overflow: hidden !important;
  }

  .search-select-width {
    width: 130px !important;
    margin-right: 5px !important;
    margin-bottom: 10px !important;
  }

  .search-input-width {
    width: 260px !important;
  }

  .el-form-item__content{
    line-height:30px !important
  }
}
.right {
  float: right;
}

.width90 {
  width: 90px !important;
}

.pages a.firstpage i,
.pages a.lastpage i {
  background: transparent !important;
}

.custom-header:after {
  content: ".";
  clear: both;
  height: 0;
  display: block;
  visibility: hidden;
}

.custom-header li {
  margin-top: 20px;
  margin-bottom: 20px;
}

.custom-header li label {
  float: left;
  width: 30%;
  padding-top: 10px;
  padding-left: 40px;
}
/* 调tool-bar */
.el-input-group__append {
  border-radius: 0 3px 3px 0 !important;
}
button.el-button.el-button--default.search-icon {
  border-left-width: 0px !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
}
// i.el-icon-search {
//   color: #d1d9de;
// }
input.el-input__inner {
  border-radius: 3px 0 0 3px;
}
.el-form-item.set-icon {
  margin-right: 8px !important;
}
/* 统一自定义风格（勿动） */
.el-dialog.el-dialog--tiny {
  width: 400px !important;
}

.el-box-table-search{
  float:right;
}
.el-table-actionBar-item{
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Equipment/EquipmentList.vue